import { defineMessages } from 'react-intl';

const messages = defineMessages({
  publicationDate: {
    id: 'Publication Date',
    defaultMessage: 'Publication Date',
  },
  filters: {
    id: 'Content Type',
    defaultMessage: 'Content Type',
  },
});

export const getContentHubFacets = (intl) => [
  {
    '@id': 'c90db813-76f9-4d23-9c10-0ac4a479f5e7',
    multiple: false,
    hidden: false,
    advanced: false,
    title: intl.formatMessage(messages.publicationDate),
    field: {
      label: intl.formatMessage(messages.publicationDate),
      value: 'effective',
    },
    type: 'daterangeFacet',
  },
  {
    '@id': 'f05c6c66-21b2-4b32-9d62-8acfa7f5a144',
    multiple: true,
    hidden: false,
    advanced: false,
    isClearable: false,
    title: intl.formatMessage(messages.filters),
    field: {
      label: intl.formatMessage(messages.filters),
      value: 'portal_type',
    },
    values: ['Image', 'Audio', 'Video'],
    type: 'selectFacet',
  },
];
